const { CHANNEL_INTERFACE_TYPE, CHANNEL_INTERFACE_TEXT } = require('@/enums');
const { getSupportChannelOptions } = require('@/tools');

module.exports = () => {
  const channelOptions = getSupportChannelOptions()
    .filter(({ value }) => value !== CHANNEL_INTERFACE_TYPE.JRTT_V3);
  if (!channelOptions.some(({ value }) => value === CHANNEL_INTERFACE_TYPE.KUAISHOU)) {
    channelOptions.push({
      label: CHANNEL_INTERFACE_TEXT.KUAISHOU,
      value: CHANNEL_INTERFACE_TYPE.KUAISHOU,
    });
  }

  return {
    type: {
      label: '媒体平台',
      type: 'select',
      props: {
        clearable: false,
      },
      options: channelOptions,
      value: CHANNEL_INTERFACE_TYPE.JRTT,
    },
    advertiser_id: {
      label: '广告主ID',
      type: 'input',
      value: '',
    },
  };
};

